import manImg from '../../../../shared/img/ppt/man_with_book.png';
import lampImg from '../../../../shared/img/ppt/lamp_and_books.png';

const addSlide3 = (pptx) => {
  const slide2 = pptx.addSlide();
  slide2.background = { color: '#c7effc' };
  slide2.addImage({
    path: lampImg,
    x: 8,
    y: 2.3,
    w: 1.5,
    h: 3.2,
  });
  slide2.addImage({
    path: manImg,
    x: 0.5,
    y: 1,
    w: 1.7,
    h: 4.5,
  });

  slide2.addText(
    [
      {
        text: 'CREATION DE VOTRE COMPTE',
        options: {
          fontSize: 42,
          color: '696969',
          breakLine: true,
          bold: true,
        },
      },
    ],
    {
      x: 2,
      y: 1.8,
      w: 6,
      h: 2,
      align: 'center',
    },
  );
};

export default addSlide3;
